module.exports = __webpack_public_path__ + "static/media/bind-course.acc6e6e8.png";